import React from 'react';
import { Helmet } from 'react-helmet-async';

const Meta = ({ 
  title = 'Patio Púrpura - Pan de Masa Madre Artesanal',
  description = 'Emprendimiento de una tica amante del pan y del buen café. Pan artesanal hecho en casa con paciencia y amor. Porque todo lo bueno toma su tiempo.',
  keywords = 'pan, masa madre, artesanal, Costa Rica, sourdough, pan casero',
  image = '/logo512.png',
  url = 'https://patiopurpura.com',
  type = 'website'
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Patio Púrpura",
    "description": description,
    "url": url,
    "telephone": "+50688644774",
    "email": "patiopurpura@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "CR"
    },
    "openingHours": "Tu-Th 09:00-18:00",
    "priceRange": "$$",
    "servesCuisine": "Pan Artesanal",
    "image": `${url}${image}`,
    "sameAs": [
      "https://www.instagram.com/patiopurpura"
    ]
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Patio Púrpura" />
      <meta name="robots" content="index, follow" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${url}${image}`} />
      <meta property="og:site_name" content="Patio Púrpura" />
      <meta property="og:locale" content="es_CR" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={`${url}${image}`} />
      
      {/* Additional Meta Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#ea9d43" />
      <meta name="msapplication-TileColor" content="#ea9d43" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/logo192.png" />
      
      {/* Preconnect for performance */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    </Helmet>
  );
};

export default Meta; 